<template>
  <el-dialog
    append-to-body
    width="800px"
    :title="`${curRow.employee_name}-修改信息`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <div>注意以下内容不支持修改:</div>
    <div style="margin:10px 0px" v-if="disabled_titles && disabled_titles.length">{{disabled_titles.join('、')}}
      <span>; 以系统为准</span>
    </div>
    <el-descriptions :column="3" :size="subUnitSize" border>
      <el-descriptions-item
        :label="item.label"
        v-for="(item, index) in fields"
        :key="index"
      >
        <el-input
          v-model="curRow[item.name]"
          style="width: 100%"
          clearable
          :size="subUnitSize"
        ></el-input>
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      curRow: {},
      fields: [],
      disabled_titles:[],
    };
  },
  methods: {
    // 获取详情
    getDetail(row, fields , disabled_titles) {
      // 使用深拷贝避免修改原始数据
      this.curRow = JSON.parse(JSON.stringify(row));
      this.fields = fields;
      this.disabled_titles = disabled_titles;
    },
    reset(done) {
      this.curRow = {};
      this.fields = [];
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$confirm("请确认操作？", "提示", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            let obj = JSON.parse(JSON.stringify(this.curRow));
            //过滤出显示的字段传给后台
            for ( let key in obj ) {
              let isHas = this.fields.find(item => item.name === key);
              if(!isHas){
                delete obj[key];
              } 
            }
            //再把字段名改成中文
            let obj2 = {};
            for (let key in obj) {
              let isHas = this.fields.find(item => item.name === key);
              if(isHas && isHas.label !== undefined){
                obj2[isHas.label] = obj[key];
              }
            }
            this.$http
              .post("/admin/finance/editDetail", {
                id: this.curRow.id,
                fields: JSON.stringify(obj2),
              })
              .then((res) => {
                if (res.code === 1) {
                  this.$message.success("操作成功！");
                  this.toggle(false);
                  this.$emit("refresh");
                }else {
                  this.$message.error(res.msg);
                }
              });
            done();
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
</style>